import React from 'react';

import type {ArtifactVersionMetricPlotReady} from './artifactVersionMetricPlotModel';
import {ArtifactVersionMetricXYPlotFrame} from './ArtifactVersionMetricXYPlotFrame';

type ArtifactVersionMetricScatterChartProps = {
  plot: ArtifactVersionMetricPlotReady;
  width: number;
  height: number;
};

export const ArtifactVersionMetricScatterChart: React.FC<
  ArtifactVersionMetricScatterChartProps
> = ({plot, width, height}) => (
  <ArtifactVersionMetricXYPlotFrame
    plot={plot}
    width={width}
    height={height}
    connectPoints={false}
  />
);
